import { render, staticRenderFns } from "./FeatureIconBox.vue?vue&type=template&id=2b641322&scoped=true&"
import script from "./FeatureIconBox.vue?vue&type=script&lang=js&"
export * from "./FeatureIconBox.vue?vue&type=script&lang=js&"
import style0 from "./FeatureIconBox.vue?vue&type=style&index=0&id=2b641322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b641322",
  null
  
)

export default component.exports